import { Buffer } from 'buffer'
import { HealthCareService } from '@saas/interfaces/graphql'
import { getSessionToken } from '../api/auth'

function btoa(str: string | Buffer): string {
    let buffer

    if (str instanceof Buffer) {
        buffer = str
    } else {
        buffer = Buffer.from(str.toString(), 'binary')
    }

    return buffer.toString('base64')
}

async function generateUrl(hcs: HealthCareService): Promise<string> {
    const { address } = hcs

    const type = hcs.type ? hcs.type.name : ''
    const token = await getSessionToken()
    const encoded = address
        ? btoa(
              `${hcs.name || ''}/${type || ''}/${address.street || ''}, ${address.postalCode || ''} ${
                  address.city || ''
              }/${token}`,
          )
        : ''
    return encoded
}

export { generateUrl }
